<template>
	<div>
		<mt-header fixed :title="isLogin ? '工程模式' : '工程模式(未登录)'"></mt-header>

		<div class="debug-content">
			<mt-cell title="版本：" class="mt-cell-wz">
				<span class="mt-cell-span">
					{{versions}}
					<br />
					{{uvVsersions}}
          <br/>
          {{schoolVersion}}
				</span>
			</mt-cell>

			<mt-cell title="用户id：" class="mt-cell-wz">
				<span class="mt-cell-span">{{userInfo.id}}</span>
			</mt-cell>

			<mt-cell title="oppenId：" class="mt-cell-wz">

				<span class="mt-cell-span">
					{{openid}}
					<button v-if="openid != null" size="small" plain v-clipboard:copy="openid" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</button>
				</span>
			</mt-cell>

			<mt-cell title="账号：" class="mt-cell-wz">
				<span class="mt-cell-span">{{userInfo.phone}}</span>
			</mt-cell>

			<mt-cell title="密码：" class="mt-cell-wz">
				<span class="mt-cell-span">{{passwd}}</span>
			</mt-cell>

			<mt-cell title="会员编号：" class="mt-cell-wz">
				<span class="mt-cell-span">{{userInfo.memberNo}}</span>
			</mt-cell>

			<mt-cell title="头像：" class="mt-cell-wz">
				<span class="mt-cell-span">
					<img :src="userInfo.headUrl" class="user-img" />
					<span>{{userInfo.headUrl}}</span>
					<button size="small" plain v-clipboard:copy="userInfo.headUrl" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</button>
				</span>
			</mt-cell>

			<mt-cell title="昵称：" class="mt-cell-wz">
				<span class="mt-cell-span">{{userInfo.nick}}</span>
			</mt-cell>

			<mt-cell title="创建时间：" class="mt-cell-wz">

				<span class="mt-cell-span">
					{{times}} <br />
					{{timesLocal}}
				</span>
			</mt-cell>

			<mt-cell title="参与零售：" class="mt-cell-wz">
				<span class="mt-cell-span" v-if="userInfo.retailAgent">是</span>
				<span class="mt-cell-span" v-if="!userInfo.retailAgent">否</span>
			</mt-cell>

			<mt-cell title="参与团队：" class="mt-cell-wz">
				<span class="mt-cell-span" v-if="userInfo.teamAgent">是</span>
				<span class="mt-cell-span" v-if="!userInfo.teamAgent">否</span>
			</mt-cell>

			<hr style="width: 100%;" />

			<mt-cell title="clientId：" class="mt-cell-wz">
				<span class="mt-cell-span">
					{{divice.clientId}}
					<button size="small" plain v-clipboard:copy="divice.clientId" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</button>
				</span>
			</mt-cell>

			<mt-cell title="token：" class="mt-cell-wz">
				<div class="mt-cell-span">
					{{auth.token}}
					<button size="small" plain v-clipboard:copy="auth.token" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</button>
				</div>
			</mt-cell>

			<mt-cell title="终端类型：" class="mt-cell-wz">
				<span class="mt-cell-span">{{divice.type}} 浏览器 | {{divice.system}}系统</span>
			</mt-cell>

			<mt-cell title="user-agent：" class="mt-cell-wz">
				<span class="mt-cell-span">{{divice.ua}}</span>
			</mt-cell>

			<hr style="width: 100%;" />

			<div>
				<div class="debug-button" v-if="isLogin">
					<mt-button size="small" @click="clearServerToken()">从服务器清除openid</mt-button>
					<mt-button size="small" v-clipboard:copy="loginHref" v-clipboard:success="onCopy" v-clipboard:error="onError">复制可登陆链接</mt-button>
				</div>

				<div class="debug-button">
					<mt-button size="small" @click="clearLocalToken()">删除本地token</mt-button>
					<mt-button size="small" @click="clearLocalClientId()">删除本地clentId</mt-button>
				</div>
				<div class="debug-button">
					<mt-button size="small" @click="refreshPage()">刷新当前页面</mt-button>
					<mt-button size="small" @click="reportLocal(reportInfo)">上报以上所有数据</mt-button>
				</div>

			</div>
			<mt-button size="small" type="primary" @click="cleanUserInfo()" style="width: 80%;margin-bottom: 20px;margin-left: 10%;">清空自己的数据和痕迹从头再来</mt-button>

			<div v-if="!isLogin">
				<router-link to="/login/begin?refer=/debug/info" replace>
					<mt-button size="small" type="primary" style="width: 80%;margin-bottom: 20px;margin-left: 10%;">目前没有登录去登陆</mt-button>
				</router-link>
			</div>

		</div>

	</div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import UserFetch from '../../fetch/user';
import { Toast } from 'mint-ui';
import Container from '../../utils/container.js';
import Auth from '../../utils/auth.js';
import { formate } from '../../utils/utils.js';

export default {
  name: 'DebugInfo',
  meta:{page:true},
  computed: {
    ...mapGetters('user', {
      userInfo: 'getUserInfo',
      openid: 'getOpenid',
      passwd: 'getPasswd',
      version: 'getSiteVersion',
    }),
//    ...mapGetters('school', {
//      schoolVersion: 'getSchoolSiteVersion',
//    }),
    schoolVersion() {
      return this.$store.state.school.schoolVersion
    },
  },

  data() {
    console.log(process.env, process.env.UV_VERSION);
    return {
      auth: {
        token: undefined,
      },
      versions: undefined,
      times: undefined,
      timesLocal: undefined,
      uvVsersions: process.env.UV_VERSION,
      /* 用户 */
      user: {},
      isLogin: false,
      /*
      设备
      */
      loginHref: undefined, //登陆地址
      reportInfo: {
        report: undefined,
      },
      divice: {
        clientId: undefined,
        type: undefined,
        ua: undefined,
      },
    };
  },

  created: function() {
    this.$store.dispatch('user/getSiteVersion');
    this.$store.dispatch('school/getSchoolSiteVersion');
    if (Auth.loginUser()) {
      this.isLogin = true;
      this.$store.dispatch('user/getUserInfo');
      this.$store.dispatch('user/getOpenid');
      this.$store.dispatch('user/getPasswd');
    } else {
      this.isLogin = false;
    }

    this.divice.clientId = Container.localGet('clientId');
    //  this.divice.clientId = localStorage.getItem("x-client-id")
    this.divice.type = Container.feature('weixin') ? '微信' : '非微信';
    this.auth.token = Auth.getToken();
    this.divice.ua = navigator.userAgent;
    this.loginHref = location.origin + '/?token=' + Auth.getToken();
    setTimeout(() => {
      this.times = this.userInfo.createDate;
      this.timesLocal = formate(this.userInfo.createDate);
      this.versions = this.version;
      let local = {
        version: this.version,
        uvVsersions: this.uvVsersions,
        loginHref: this.loginHref,
        clientId: this.divice.clientId,
        openid: this.openid,
        token: this.auth.toke,
        diviceType: this.divice.type,
        diviceUa: this.divice.ua,
        userInfo: JSON.stringify(this.userInfo),
      };
      this.reportInfo.report = JSON.stringify(local);
    }, 1000);

    //divice.system =
  },

  methods: mapActions('user', [
    'onError',
    'onCopy',
    'clearServerToken',
    'clearLocalToken',
    'clearLocalClientId',
    'refreshPage',
    'reportLocal',
    'cleanUserInfo',
  ]),
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../../assets/css/debugInfo.css';
</style>




// WEBPACK FOOTER //
// src/components/page/DebugInfo.vue